import type { App } from 'vue'
import emitter from 'tiny-emitter/instance'

export type ThModalListener = (
  name: string,
  state: boolean | null,
  params?: unknown
) => void

export interface ThModal {
  debug?: boolean
  app?: App
  listen: (cb: ThModalListener) => void
  show: (name: string, params?: unknown) => void
  hide: (name: string, params?: unknown) => void
  toggle: (name: string, params?: unknown) => void
}

export interface ThModalPluginOptions {
  debug?: boolean
}

const thModalPlugin = {
  install: (app: App, options: ThModalPluginOptions = {}) => {
    const thModal: ThModal = {
      debug: options.debug || false,
      app,

      listen: (cb) => emitter.on('thmodal', cb as (...args: unknown[]) => void),

      show: (name, params) => {
        emitter.emit('thmodal', name, true, params)
      },

      hide: (name, params) => {
        emitter.emit('thmodal', name, false, params)
      },

      toggle: (name, params) => {
        emitter.emit('thmodal', name, null, params)
      }
    }

    app.config.globalProperties.$thModal = thModal
    app.provide('thModal', thModal)
  }
}

export default thModalPlugin
